var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "actives" },
    [
      _vm.type == "image"
        ? _c("img", { staticClass: "imgActive", attrs: { src: _vm.logoUrl } })
        : _vm._e(),
      _vm._v(" "),
      _vm.type == "banner"
        ? _c("img", {
            staticClass: "bannerActive",
            attrs: { src: _vm.logoUrl }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.cardList, function(item, idx) {
        return _c("div", { key: item.id, staticClass: "noUse_item" }, [
          _c("div", { staticClass: "noUse_top" }, [
            _c("div", { staticClass: "noUse_topOne" }, [
              _c("p", { staticClass: "noUse_num" }, [
                _vm._v("\n          ￥"),
                _c("span", [
                  _vm._v(
                    _vm._s(item.discountRule && item.discountRule.discount)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "noUse_canUse" }, [_vm._v("优惠券")])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("p", { staticClass: "noUse_center" }, [
                _vm._v(_vm._s(item.name))
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.validPeriodType === 2,
                      expression: "item.validPeriodType === 2"
                    }
                  ],
                  staticClass: "noUse_centerTime"
                },
                [
                  _vm._v(
                    "\n          领取后" +
                      _vm._s(item.validPeriodRule.duration) +
                      "天内有效\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.validPeriodType === 1,
                      expression: "item.validPeriodType === 1"
                    }
                  ],
                  staticClass: "noUse_centerTime"
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm
                          .moment(item.validPeriodRule.from)
                          .format("YYYY-MM-DD")
                      ) +
                      "-\n          " +
                      _vm._s(
                        _vm.moment(item.validPeriodRule.to).format("YYYY-MM-DD")
                      ) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "userules",
                  on: {
                    click: function($event) {
                      return _vm.showDetail(item, _vm.rules[idx])
                    }
                  }
                },
                [_vm._v("\n          使用规则>\n        ")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "useButton",
                class: item.getStatus === true ? "getTrue" : "getFalse",
                on: {
                  click: function($event) {
                    return _vm.getCoupon(item.id, item.getStatus)
                  }
                }
              },
              [_vm._v("\n        立即领取\n      ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showToast,
                  expression: "showToast"
                }
              ],
              staticClass: "toasts"
            },
            [_vm._v(_vm._s(_vm.toastText))]
          )
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "returns" }, [_c("Return")], 1),
      _vm._v(" "),
      _vm.details ? _c("div", { staticClass: "mask" }) : _vm._e(),
      _vm._v(" "),
      _vm.details
        ? _c("div", { staticClass: "detail_box" }, [
            _c("p", { staticClass: "usetit" }, [_vm._v("使用规则")]),
            _vm._v(" "),
            _c("p", { staticClass: "detail_p" }, [_vm._v(_vm._s(_vm.rule))]),
            _vm._v(" "),
            _c("p", { staticClass: "detail_p" }, [_vm._v(_vm._s(_vm.shops))]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "agree",
                on: {
                  click: function($event) {
                    return _vm.agrees()
                  }
                }
              },
              [_vm._v("我知道了")]
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ed22f47", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ed22f47","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Actives/index.vue
// module id = null
// module chunks = 